import React from 'react';
import { useAuth } from '../contexts/auth';
import { getCookie, setSidInCookies, getSourceValue, touchSource } from '../lib/common';

const ChatbotRedirect = () => {
  const [authState] = useAuth();
  const { sidResponse } = authState;

  React.useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const urlSid = queryParams.get('sid');
    const refId = queryParams.get('ref_id') || "";
    const cookieSid = getCookie('sid');
    const sid = sidResponse || urlSid || cookieSid || '';
    const source = getSourceValue() || '2';
    //Chat bot url
    const redirectUrl = `https://cs.justdial.com/chat?wkwebview=1&source=${source}&ref_id=${refId}`;

    const performRedirection = (url) => {
      // iOS Native Redirection (detected via webkit message handler presence)
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.callbackHandler) {
        const paramsIos = {
          type: 'deeplinkJD',
          shareText: 'Redirection',
          shareUrl: url,
        };
        window.webkit.messageHandlers.callbackHandler.postMessage(JSON.stringify(paramsIos));
        return;
      }

      // Android Native Redirection (detected via JdLiteInterface presence)
      if (window.JdLiteInterface && window.JdLiteInterface.openUrlInWindow) {
        const data = {
          ürl: url,
          header: '',
          confirmationheader: '',
          hide_header: 1,
          webviewhistory: 0,
          transaction: 0,
        };
        window.JdLiteInterface.openUrlInWindow(JSON.stringify(data));
        return;
      }

      // Web/Browser fallback
      window.location.href = url;
    };

    if (sid) {
      if (urlSid) {
        setSidInCookies(urlSid);
      }
      performRedirection(redirectUrl);
    } else {
      const loginRedirectUrl = encodeURIComponent(window.location.href);

      // iOS Native Login Check
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.callbackHandler) {
        const logjson = JSON.stringify({ type: 'verticalLogin', fn: 'nativeLogin', fnc: 'nativeLogin' });
        window.webkit.messageHandlers.callbackHandler.postMessage(logjson);
        return;
      }

      // Android Native Login Check
      if (window.JdLiteInterface && window.JdLiteInterface.verticalLogin) {
        if (['51', 51].includes(source)) {
          try {
            const busJSON = window.JdLiteInterface.getLoginData();
            const dataJSON = JSON.parse(busJSON);
            const nativeSid = dataJSON.sid;
            if (nativeSid) {
              setSidInCookies(nativeSid);
              performRedirection(redirectUrl);
              return;
            }
          } catch (e) {
            console.error('Error getting Android login data', e);
          }
        }
        const logjson = JSON.stringify({ fn: 'nativeLogin', fnc: 'nativeLogin' });
        window.JdLiteInterface.verticalLogin(logjson);
        return;
      }

      // Web/Touch Fallback Login
      if (touchSource.includes(source)) {
        window.location.href = `https://www.justdial.com/login?redirect=${loginRedirectUrl}&redirectionurl=${loginRedirectUrl}`;
      } else {
        window.location.href = `https://www.justdial.com/login?redirectionurl=${loginRedirectUrl}`;
      }
    }
  }, [sidResponse]);

  return null;
};

export default ChatbotRedirect;
